import { Component, Input, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FilterEngineService} from "../../../service/filter-engine.service";
import {getKindSearchCategories, IKind} from "../../../models/IKind.interface";
import {IEltern} from "../../../models/IEltern.interface";

@Component({
  selector: 'app-select-kind',
  templateUrl: './select-kind.component.html',
  styleUrls: ['./select-kind.component.scss']
})
export class SelectKindComponent implements OnInit {

  @Input() eltern?: IEltern;
  public kinder: IKind[] = [];
  public query = "";
  public categories = getKindSearchCategories();

  constructor(
      public activeModal: NgbActiveModal,
      private filterService: FilterEngineService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.updateFilter();
  }

  async updateFilter(): Promise<void> {
    const list = this.eltern ? this.eltern.kinder : [];
    this.kinder = await this.filterService.filter(
        this.query,
        list,
        "selectKindDialog"
    );
  }

  select(kind: IKind): void {
    this.activeModal.close(kind);
  }

}
